// extracted by mini-css-extract-plugin
module.exports = {"col_box":"col_box--8yOdYDd","col_navlist":"col_navlist-1ZGcTR9X","pa":"pa-2YPyEWEo"};